import { IconTriangle } from "../TriangleIcon";
import { cn } from "@/core/helpers/cn";
import displaySmImg from "@/domains/estate/components/elevator/res/display-business-sm@2x.png";

export function ElevatorStandardDirectionDisplay({
  targetFloor,
  currentFloor,
}: {
  targetFloor: number;
  currentFloor: number;
}) {
  const isMoving = targetFloor !== null && targetFloor !== currentFloor;
  const direction = targetFloor > currentFloor ? "up" : "down";
  const isUp = isMoving && direction === "up";
  const isDown = isMoving && direction === "down";

  return (
    <div className="relative w-[52px] h-[72px]">
      <img src={displaySmImg} alt="" className="absolute inset-0 w-full h-full object-contain" />

      <div className="absolute top-[14px] right-[14px] flex justify-center items-center flex-col text-[#3f3f3f]">
        <IconTriangle className={cn("relative top-[4px]", isUp && "text-[#ff4e4e]")} />
        <IconTriangle
          className={cn("relative -top-[4px] rotate-180", isDown && "text-[#ff4e4e]")}
        />
      </div>
    </div>
  );
}
